import type { LocaleModule } from '@lit/localize';
import { configureLocalization } from '@lit/localize';
import { sourceLocale, targetLocales } from './generated/locale-codes';

// Loader-Map nur für targetLocales (sourceLocale hat keine Datei)
const loaders: Record<string, () => Promise<LocaleModule>> = {
  de: () => import('./generated/locales/de.js'),
};

export const { getLocale, setLocale } = configureLocalization({
  sourceLocale,
  targetLocales,
  loadLocale: async (locale: string): Promise<LocaleModule> => {
    const loader = loaders[locale];
    if (!loader) {
      // sollte nie passieren, weil loadLocale nur mit targetLocales aufgerufen wird
      throw new Error(`Unknown target locale: ${locale}`);
    }
    return loader();
  },
});
